type SearchRefineValue = string | string[]
type ListingLayout = 'grid2' | 'grid3'

type ProductListingPaginationStateParams = {
    currentHitsCount: number
    total?: number
    start: number
    end: number
    limitByTemplate: number
    hasBannerHalf: boolean
    listingLayout: ListingLayout
}

type ProductListingStateParams<T> = {
    hits?: T[]
    refine?: Record<string, SearchRefineValue>
    hasBannerHalf: boolean
    truncateLastProducts: boolean
    maxProductsCount?: number
}

type ProductListingState<T> = {
    hasActiveRefinements: boolean
    shouldRenderEditorialModules: boolean
    shouldRenderBannerHalf: boolean
    productsToRender?: T[]
    productTileIndexOffset: number
}

type ProductListingPaginationState = {
    paginationLimit: number
    hasMoreProductsToLoad: boolean
    isInitialProductListingPage: boolean
    truncateLastProducts: boolean
}

const getProductListingPaginationState = ({
    currentHitsCount,
    total,
    start,
    end,
    limitByTemplate,
    hasBannerHalf,
    listingLayout,
}: ProductListingPaginationStateParams): ProductListingPaginationState => {
    const paginationLimit = limitByTemplate > 0 ? limitByTemplate : 20
    const hasMoreProductsToLoad = typeof total === 'number' && currentHitsCount < total
    const isInitialProductListingPage = start === 0 && (end === 0 || end === paginationLimit)
    const truncateLastProducts = hasBannerHalf && listingLayout === 'grid3' && start === 0 && hasMoreProductsToLoad

    return {
        paginationLimit,
        hasMoreProductsToLoad,
        isInitialProductListingPage,
        truncateLastProducts,
    }
}

const getProductListingState = <T>({hits, refine, hasBannerHalf, truncateLastProducts, maxProductsCount}: ProductListingStateParams<T>): ProductListingState<T> => {
    const hasActiveRefinements = Object.keys(refine ?? {}).length > 0
    const shouldRenderEditorialModules = !hasActiveRefinements
    const shouldRenderBannerHalf = hasBannerHalf && shouldRenderEditorialModules
    const normalizedHits = typeof maxProductsCount === 'number' ? hits?.slice(0, maxProductsCount) : hits

    return {
        hasActiveRefinements,
        shouldRenderEditorialModules,
        shouldRenderBannerHalf,
        productsToRender: shouldRenderBannerHalf ? normalizedHits?.slice(4, truncateLastProducts ? -2 : undefined) : normalizedHits,
        productTileIndexOffset: shouldRenderBannerHalf ? 4 : 0,
    }
}

export {getProductListingPaginationState, getProductListingState}
